import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "./Languagecontext";
import { headTags, pageMeta } from "../seo/meta";

/**
 * بيحدّث عنوان الصفحة والوصف والـ canonical والـ hreflang والـ JSON-LD لما تتنقل بين الصفحات.
 * الاستخدام في أي صفحة: useSeo()  (بياخد الرابط الحالي لوحده)
 */
export const useSeo = (pathOverride) => {
  const { t, lang } = useLang();
  const { pathname } = useLocation();
  const path = pathOverride || pathname || "/";

  useEffect(() => {
    const m = pageMeta(t, lang, path);
    document.title = m.title;
    document.head.querySelectorAll("[data-seo]").forEach((el) => el.remove());
    const tpl = document.createElement("template");
    tpl.innerHTML = headTags(m);
    document.head.append(...tpl.content.childNodes);
  }, [t, lang, path]);
};
